import FaceEnroll from '../../../../assets/face-enroll.svg?react';
import './start-enrollment-header.less';

export const StartEnrollmentHeader = () => {
  return (
    <div className="start-enrollment-header">
      <FaceEnroll />
    </div>
  );
};
